import { PromoSlider } from '@intigral/ui';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import useLanguage from '../../../hooks/useLanguage';
import { __ } from '../../../translations';
import useGetReadyPromotions from '../hooks/useGetReadyPromotions';
import { usePromotionUtils } from '../hooks/useMainPromotions';
import { createPromotionObject } from '../utils/promotions';
import PromoSlideTrailer from './presentation/SlideTrailer';
import SimpleBitmovinPlayer from '../../../helpers/SimpleBitmovinPlayer';

const MainBanner = ({ name, carousel }) => {
    // Hooks
    const language = useLanguage();
    const promoUtils = usePromotionUtils(name);
    // Using React Query instead of Redux for configuration
    const configuration = useConfigurationSections();
    const { promoAutoTrailer, promoBannerLiveStream, config } = configuration;
    const { promoAutoTrailerEnable = false } = (promoAutoTrailer as any) || {};
    const { enableAutoplay = false } = (promoBannerLiveStream as any) || {};
    const { promotions, isLoading, isError, isSuccess, isFetching } = useGetReadyPromotions(carousel);
    const shouldShowLoader = (isLoading || isFetching) && !(isError || isSuccess);

    return (
        <PromoSlider
            isRTL={language === 'ar' ? true : false}
            promotions={
                Array.isArray(promotions)
                    ? promotions.map((p) => {
                          const promo = createPromotionObject(p, promoUtils, language);
                          return promo;
                      })
                    : null
            }
            promoAutoTrailerEnable={promoAutoTrailerEnable}
            liveStreamAutoPlayEnable={enableAutoplay}
            Trailer={PromoSlideTrailer}
            Player={SimpleBitmovinPlayer}
            trailerDelay={config?.promoSlider?.trailerDelay || 1000}
            id={carousel?.id}
            isLoading={shouldShowLoader}
        />
    );
};

export default MainBanner;
